// extracted by mini-css-extract-plugin
module.exports = {"popoverWithIconWrap":"popoverWithIcon_popoverWithIconWrap__IIhNg","footer":"popoverWithIcon_footer__eNen5"};